module.exports = __webpack_public_path__ + "static/img/block2.aa962d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parkDescription/block2.png
// module id = IxQ5
// module chunks = 1